// extracted by mini-css-extract-plugin
export var card = "_om-0";
export var content = "_om-2";
export var details = "_om-3";
export var icon = "_om-1";
export var iconBlue = "_om-5";
export var iconBrand = "_om-4";
export var iconGrayBlue = "_om-6";
export var iconGreen = "_om-7";
export var iconIndigo = "_om-8";
export var iconOrange = "_om-9";
export var iconPurple = "_om-a";
export var iconRed = "_om-b";
export var iconWarning = "_om-c";